import Chart from '../plugins/Chart.min';
window.Chart = Chart;



//////////////////
// WEBPACK FOOTER
// ./src/js/components/global/global-chart.js
// module id = 4
// module chunks = 0